import qs from 'qs';
import axios from 'axios';
import store from '@/store';

function getClientPlaybacks(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true, encode: false });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/clients${query}`);
}

function getPlaybacks() {
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/clients`);
}

function getPlaybackPerformance(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/clients/playback-detail${query}`);
}

function getPlaybackEvents(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  const { projectId } = store.getters.currentProject;
  return axios.get(`/projects/${projectId}/clients/playbacks${query}`);
}

export {
  getPlaybackPerformance,
  getPlaybackEvents,
  getClientPlaybacks,
  getPlaybacks,
};
